import React from 'react';

export const AttentionIconLarge = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
  >
    <rect
      x="1.25"
      y="0.75"
      width="28.5"
      height="28.5"
      rx="14.25"
      stroke="#27B0E0"
      strokeWidth="1.5"
    />
    <path
      d="M15.5345 19.3707C15.3113 19.3707 15.1253 19.2963 14.9765 19.1475C14.8463 18.9987 14.7719 18.7755 14.7533 18.4779L14.1953 5.9787C14.1767 5.5323 14.279 5.1789 14.5022 4.9185C14.744 4.6395 15.0881 4.5 15.5345 4.5C15.9623 4.5 16.2878 4.6395 16.511 4.9185C16.7342 5.1789 16.8365 5.5323 16.8179 5.9787L16.2599 18.4779C16.2599 18.7755 16.1948 18.9987 16.0646 19.1475C15.9344 19.2963 15.7577 19.3707 15.5345 19.3707ZM15.5345 24.4764C15.0695 24.4764 14.6975 24.3369 14.4185 24.0579C14.1395 23.7603 14 23.3883 14 22.9419C14 22.4955 14.1395 22.1328 14.4185 21.8538C14.6975 21.5562 15.0695 21.4074 15.5345 21.4074C15.9995 21.4074 16.3622 21.5562 16.6226 21.8538C16.9016 22.1328 17.0411 22.4955 17.0411 22.9419C17.0411 23.3883 16.9016 23.7603 16.6226 24.0579C16.3622 24.3369 15.9995 24.4764 15.5345 24.4764Z"
      fill="#27B0E0"
    />
  </svg>
);
